<template>
    <div v-on:blur="closeModal()" class="offcanvas offcanvas-end" id="card-detail-view-autoload-canvas" tabindex="-1" role="dialog" aria-labelledby="card-detail-view-autoload-canvas-label" aria-hidden="true" v-if="card">
        <div class="offcanvas-header">
            <div class="w-100">
                <h3 class="text-center text-dark">
                    {{ card.name }}
                    <img v-if="card.hasOwnProperty('is_in_set_collection') && !card.is_in_set_collection" src="/assets/dipocaco/icons/new.webp" alt="series-symbol" class="card-new-marker">
                    <span v-if="card.amount > 1" class="ml-2 badge rounded-pill bg-info" v-text="card.amount"></span>
                    <a href="javascript:" v-on:click="closeModal()"><i class="fa-solid fa-times float-end" style="font-size: 1.5em;"></i></a>
                </h3>
            </div>
        </div>
        <div class="offcanvas-body">
            <img v-on:click="console.log(card)" :src="getCardImageUrl(card)" class="card-image mb-3" alt="card image"/>
            <div v-if="card.set" style="height: 5em;">
                <img class="float-end set-logo mb-3" :src="card.set.images.logo" alt=""/>
                <strong>Set: </strong> {{ card.set.name }} <img v-if="card.set.id !== 'base1'" class="set-icon" :src="card.set.images.symbol"/><br/>
                <strong>Series: </strong>{{ card.set.series }}
            </div>

            <span v-if="card.artist">
                <strong>Artist:</strong> {{ card.artist }}<br/>
            </span>

            <span v-if="card.rarity">
                <strong>Rarity:</strong> {{ card.rarity }}<br/>
            </span>

            <span v-if="card.types">
                <strong>Type: </strong> <img v-for="type in card.types" :src="'/assets/dipocaco/type-icons/'+type+'.png'" alt=""><br/>
            </span>

            <div class="row p-0" v-if="card.weaknesses || card.resistances">
                <span v-if="card.weaknesses" class="col-6 p-0">
                    <strong>Weakness:</strong>
                    <span v-for="weakness in card.weaknesses">
                        <img :src="'/assets/dipocaco/type-icons/'+weakness.type+'.png'" alt=""> {{ weakness.value }}
                    </span>
                    <br/>
                </span>

                <span v-if="card.resistances !== null" class="col-6 p-0">
                    <strong>Resistance:</strong>
                    <span v-for="resistance in card.resistances">
                        <img :src="'/assets/dipocaco/type-icons/'+resistance.type+'.png'" alt=""> {{ resistance.value }}
                    </span>
                    <br/>
                </span>
            </div>

            <a v-if="card.cardmarket" :href="card.cardmarket.url" class="btn w-100 mb-2 text-center text-white" target="_blank" style="background-color: #012169">
                Show on <img src="/assets/dipocaco/cardmarket.png" style="height: 1.1em;">
            </a>

            <div class="row p-0">
                <div class="col-6 pl-0">
                    <a :href="getLinkToCard(card)" class="btn btn-dark w-100"><i class="fa-solid fa-arrow-up-right-from-square"></i> Link</a>
                </div>
                <div class="col-6 pr-0">
                    <a href="javascript:" v-if="canShare" v-on:click="shareCard()" class="btn btn-dark w-100"><i class="fa-solid fa-share-from-square"></i> Share</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CardService from "../../CardService";

export default {
    name: "CardDetailViewAutoLoadCanvas",
    data() {
        return {
            card: null,
        }
    },
    watch: {
        cardId(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.fetchCardData();
            }
        }
    },
    computed: {
        canShare() {
            return navigator.share;
        },
        cardId() {
            return this.$store.state.selectedCardForAutoLoadCanvas;
        }
    },
    methods: {
        fetchCardData() {
            axios.get('/api/cards/' + this.cardId).then((response) => {
                this.card = response.data;
                console.log(response.data)
                this.$forceUpdate();
            });
        },
        getPrice(card) {
            return CardService.getPrice(card);
        },
        closeModal() {
            $("#card-detail-view-autoload-canvas").offcanvas('hide');
        },
        shareCard() {
            if (navigator.share) {
                let imageSource = CardService.getCardImageUrl(this.card);

                fetch(imageSource)
                    .then(r => r.blob())
                    .then(r => {
                        let file = new File([r], 'Card.png', {
                            type: 'image/png',
                        });

                        navigator.share({
                            title: this.card.title + ' on Dipocaco',
                            text: 'Found a nice card from ' + this.card.set.name + '!',
                            url: 'https://dipocaco.me/card/' + this.card.id,
                            files: [file]
                        }).then(() => console.log('Successful share'))
                    })
            }
        },
        getCardImageUrl(card) {
            return CardService.getCardImageUrl(card);
        },
        getLinkToCard(card) {
            return '/card/' + card.id;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-image {
    max-width: 100%;
    border-radius: 10px;
}

.currency-icon {
    max-height: 2em;
}

.set-logo {
    max-height: 3em;
}

.set-icon {
    max-height: 1.8em;
}

.modal-footer {
    display: flex;
    justify-content: space-evenly;
}

.card-new-marker {
    margin-top: -0.2em;
    margin-left: 0.2em;
    height: 1em;
    display: inline-block;
}
</style>
